import repositories from '..';

const resource = '/integration/api-keys';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
